import type { SizeUnit, Size, Sides } from './types';
import { parseValueWithUnit } from '@wix/editor-elements-common-utils';

export const toSize = (
  rawSize: string | number | undefined,
): Size | undefined => {
  const parsedSize = parseValueWithUnit(`${rawSize}`);
  if (!parsedSize) {
    return;
  }

  const { value, unit } = parsedSize;
  return {
    propertyType: 'Size',
    unit: unit as SizeUnit,
    value,
  };
};

export const toSides = (rawSides: string | undefined): Sides | undefined => {
  if (!rawSides?.length) {
    return;
  }

  const sides = rawSides.split(' ').map(toSize).filter(Boolean) as Array<Size>;

  if (!sides) {
    return;
  }

  return {
    propertyType: 'Sides',
    sides,
  };
};

export const stringifySize = (size: Size | undefined): string =>
  size ? `${size.value}${size?.unit || ''}` : '';

export const stringifySides = (sizes: Sides): string =>
  sizes.sides.map(stringifySize).join(' ');
